


























import { Component, Vue } from 'vue-property-decorator';

const ParallaxProps = Vue.extend({
  props: {
    index: {
      type: Number,
      required: true,
      default: 1,
    },

    alt: {
      type: String,
      required: true,
    },

    speed: {
      type: Number,
      default: 0.3,
    },

    height: {
      type: String,
      default: '65vh',
    },

    maxHeight: {
      type: String,
      default: '65vh',
    },
  },
});

  @Component
export default class ParallaxSection extends ParallaxProps {
    private parallaxHeight: number = 0;

    private translation: String = 'translateY(0px)';

    private actualSpeed: number = 0.0;

    handleScroll() {
      this.updateSpeed();

      const height = (window.innerHeight || document.documentElement.clientHeight);

      const translationPx = -(height + this.parallaxHeight - this.$el.getBoundingClientRect().top)
        * this.actualSpeed;

      this.translation = `translateY(${translationPx}px)`;
    }

    updateSpeed() {
      const height = (window.innerHeight || document.documentElement.clientHeight);

      const $imgEl = this.$el.children.item(0);

      if ($imgEl !== null) {
        const imageHeight = $imgEl.getBoundingClientRect().height;
        this.parallaxHeight = this.$el.getBoundingClientRect().height;

        this.actualSpeed = Math.min((imageHeight - this.parallaxHeight) / (height
          + 2 * this.parallaxHeight), this.speed);
      }
    }

    mounted() {
      this.updateSpeed();

      document.addEventListener('scroll', this.handleScroll);

      window.setTimeout(this.handleScroll, 500);
    }

    beforeDestroy() {
      document.removeEventListener('scroll', this.handleScroll);
    }
}
